import React, { FC, useState } from 'react';
import { ArrowDown, DropdownList } from 'esa-ui-library';
import { PropertyType } from 'esa-ui-library/lib/types';
import styles from './Header.module.scss';

interface NavItemProps {
	data: PropertyType;
	getActiveItem: (items: PropertyType[]) => PropertyType | undefined;
	onNavItemClick: (i: PropertyType) => void;
	getOptionTestId: (label: string) => string;
}

const NavItem: FC<NavItemProps> = ({ data, getActiveItem, onNavItemClick, getOptionTestId }): JSX.Element => {
	const [opened, setOpened] = useState(false);

	const onOpen = () => {
		setOpened(true);
	};

	const onClose = () => {
		setOpened(false);
	};

	return (
		<span className={styles.NavItem} data-testid={getOptionTestId(data.label)}>
			<div className={`${styles.ItemLabel}  ${getActiveItem(data.options) ? styles.Active : ''}`} onClick={onOpen}>
				<div>{data.label}</div>
				<i className={styles.Icon}>
					<ArrowDown />
				</i>
			</div>
			{opened && (
				<div className={styles.DropdownListBox}>
					<DropdownList
						options={data.options}
						onSelect={(option) => onNavItemClick(option)}
						selected={getActiveItem(data.options)}
						dataId={getOptionTestId(data.label)}
						onClose={onClose}
					/>
				</div>
			)}
		</span>
	);
};

export { NavItem };
